"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _routing = require("@engaging-tech/routing");
var _components = require("@engaging-tech/components");
var _useNavContext3 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _routeHighlightChecker = _interopRequireDefault(require("../../utils/routeHighlightChecker"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * An individual navigation item. This component is **desktop-only**.
 *
 * If the route this component is rendered for has any children,
 * a dropdown menu with the child routes will be visible on mouse hover.
 * @param {object} props props passed into component
 * @param {object} props.route The route to render a navigation item for.
 * @package
 */
var NavItem = function NavItem(_ref) {
  var route = _ref.route;
  var _useNavContext = (0, _useNavContext3["default"])(),
    fontFamilies = _useNavContext.fontFamilies,
    navbarItemColor = _useNavContext.navbarItemColor,
    tabBarItemColor = _useNavContext.tabBarItemColor;
  var _useState = (0, _react.useState)(false),
    highlightText = _useState[0],
    setHightlightText = _useState[1];
  var matchedRoute = typeof window !== "undefined" && (0, _routeHighlightChecker["default"])(route);
  var handleMouseHover = function handleMouseHover(isMouseEnter) {
    if (isMouseEnter) {
      setHightlightText(true);
    } else if (typeof window !== "undefined") {
      setHightlightText(matchedRoute);
    }
  };
  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      setHightlightText(matchedRoute);
    }
  }, [route]);
  return /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    position: "relative",
    as: "li",
    onMouseEnter: function onMouseEnter() {
      return handleMouseHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return handleMouseHover(false);
    },
    justifyContent: "center",
    width: "auto",
    mr: 2,
    ml: 2,
    pl: 4
  }, /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
    to: route.path,
    external: route.path.includes("#")
  }, route.linkProps), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    fontSize: 4,
    fontFamily: matchedRoute ? fontFamilies.selected : fontFamilies.unSelected,
    fontWeight: 700,
    isActive: highlightText,
    color: highlightText ? tabBarItemColor.selected || navbarItemColor.selected : tabBarItemColor.unSelected || navbarItemColor.unSelected
  }, route.description))));
};

/**
 * Renders the main navigation routes. This component
 * is **desktop-only**.
 * @package
 */
var TabBar = function TabBar() {
  var _useNavContext2 = (0, _useNavContext3["default"])(),
    routes = _useNavContext2.routes,
    tabBarColor = _useNavContext2.tabBarColor;
  var router = (0, _routing.useRouter)();
  var activeParentRoute = function () {
    var checkedParentRoutes = routes.find(function (route) {
      return router.isMatch(route.path);
    });
    if (checkedParentRoutes) {
      return checkedParentRoutes;
    }
    // Checks children of route, returns parent route
    var foundParentRouteOfChildren = routes.find(function (route) {
      if (route.children) {
        var foundChildrenRoute = route.children.find(function (childrenRoute) {
          return router.isMatch(childrenRoute.path);
        });
        if (foundChildrenRoute) {
          // Checks if private
          return foundChildrenRoute["private"] === undefined || !foundChildrenRoute["private"];
        }
      }
      return false;
    });
    if (foundParentRouteOfChildren) {
      return foundParentRouteOfChildren;
    }
    return false;
  }();
  var routeChildrenPrivateFilter = function routeChildrenPrivateFilter(activeRoutes) {
    return activeRoutes.children.filter(function (route) {
      return route["private"] === undefined || !route["private"];
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, activeParentRoute && activeParentRoute.children && routeChildrenPrivateFilter(activeParentRoute).length > 0 && /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: 1 / 1,
    justifyContent: "space-between",
    mt: 0,
    bg: tabBarColor || "",
    height: 55,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    justifyContent: "flex-start",
    as: "ul",
    alignItems: "center",
    pl: 3
  }, routeChildrenPrivateFilter(activeParentRoute).map(function (route) {
    return /*#__PURE__*/_react["default"].createElement(NavItem, {
      route: route,
      key: route.description
    });
  }))));
};
var _default = exports["default"] = TabBar;